import moment from 'moment';
import ptMessages from '../locales/pt_PT.json';
import merchandisingMessages from '../locales/merchandising';

// CRA excludes Moment's automatic locale loading. Register Portuguese without
// changing the global language for users who have another locale selected.
const previousMomentLocale = moment.locale();
require('moment/locale/pt');
moment.locale(previousMomentLocale);

const PtLang = {
  messages: {
    ...merchandisingMessages,
    ...ptMessages,
  },
  locale: 'pt-PT',
};

export default PtLang;
